import { useQuery } from '@tanstack/react-query';
import { GET, GET_LINE_MESSAGE_TEMPLATES } from '../../../../services';

export const useLineMessageTemplates = (enabled = true) =>
  useQuery({
    queryKey: ['lineMessageTemplates'],
    queryFn: async () => {
      const response = await GET(GET_LINE_MESSAGE_TEMPLATES());
      if (response?.success === false) throw new Error(response.message);
      return response?.result?.items || [];
    },
    enabled,
  });
